module.exports = __webpack_public_path__ + "static/dog-lick-ff4450b56fd5fb5b66d9cd71d69b0c27.gif";